import React from 'react';
import openAi from '../../../assets/img/jobhome/OpenAI.svg';
import anthropic from '../../../assets/img/jobhome/Anthropic.svg'
import dell from '../../../assets/img/jobhome/Dell.svg';
import disney from '../../../assets/img/jobhome/Disney.svg';
import nvidia from '../../../assets/img/jobhome/Nvidia.svg';
import pepsi from '../../../assets/img/jobhome/Pepsi.svg';
import reddit from '../../../assets/img/jobhome/Reddit.svg';
import rivian from '../../../assets/img/jobhome/Rivian.svg';
import snowFlake from '../../../assets/img/jobhome/Snowflake.svg';
import InfiniteCarousel from './components/InfiniteCarousel';
import './CompanyCarousel.scss'

const defaultItems = [
    { image: openAi, name: 'OpenAI' },
    { image: anthropic, name: 'Anthropic' },
    { image: dell, name: 'Dell' },
    { image: disney, name: 'Disney', style: {height: '50px'} },
    { image: nvidia, name: 'Nvidia' },
    { image: pepsi, name: 'Pepsi', style: {height: '50px'} },
    { image: reddit, name: 'Reddit' },
    { image: rivian, name: 'Rivian' },
    { image: snowFlake, name: 'Snowflake' }
]
const CompanyCarousel = ({ items=[] }) => {
    return (
        <>
            <div className='company-carousel-title'>Trusted by AI leaders, enterprises, and more</div>
            <InfiniteCarousel items={items.length ? items : defaultItems} />
        </>
    )
}

export default CompanyCarousel;